import { useState } from "react";
import { downloadBlob } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ExportBriefingButton({ payload, label = "Export PDF briefing", testid = "export-briefing-btn", variant = "outline", filePrefix = "briefing" }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await downloadBlob("/export/briefing", `lumis-hr-${filePrefix}-${new Date().toISOString().slice(0, 10)}.pdf`, { method: "POST", data: payload });
      toast.success("Briefing PDF downloaded");
    } catch { toast.error("Could not generate briefing"); }
    finally { setBusy(false); }
  };
  return (
    <Button data-testid={testid} onClick={run} disabled={busy} variant={variant} className={variant === "outline" ? "border-[#F5A623] text-[#7C3F00] hover:bg-[#FDECD0]" : "bg-[#0A2A5E] hover:bg-[#0F3F8A] text-white"}>
      {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <FileDown className="w-4 h-4 mr-2" />} {label}
    </Button>
  );
}
